export default "__VITE_ASSET__3L3Gnkw3__"